function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _PromoDiscount_brand = /*#__PURE__*/new WeakSet();
class PromoDiscount {
  constructor(skus, promoDiscountPercent) {
    var defaultDiscountPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    _classPrivateMethodInitSpec(this, _PromoDiscount_brand);
    this.skus = skus;
    this.promoDiscountPercent = promoDiscountPercent;
    this.defaultDiscountPercent = defaultDiscountPercent;
  }
  getDiscountPercent(sku) {
    return _assertClassBrand(_PromoDiscount_brand, this, _applies).call(this, sku) ? this.promoDiscountPercent : this.defaultDiscountPercent;
  }
  calculateDiscountedPrice(priceInCents, discountPercent) {
    var discountAmount = priceInCents * (discountPercent / 100);
    // When discounting a price in cents, we can be left with decimal places. Math.trunc removes any
    // decimal places without rounding which seems to match how Shopify applies discounts as the
    // resulting price matches what is in the cart and checkout.
    var discountedPriceInCents = priceInCents - Math.trunc(discountAmount);
    return this.formatCentsToDollars(discountedPriceInCents);
  }
  formatCentsToDollars(priceInCents) {
    var priceInDollars = priceInCents / 100;
    return '$' + priceInDollars.toFixed(2);
  }
}
function _applies(sku) {
  // If the sku list is an empty array, it applies to all products
  if (Array.isArray(this.skus) && this.skus.length === 0) {
    return true;
  }
  // Otherwise limit to specific skus
  return this.skus.includes(sku);
}
export default PromoDiscount;